import { metaAccount } from '@/router/meta-config'
const permissionKey = 'PAGE'

export default [
  // pages
  {
    path: '/pages',
    name: 'page-pages',
    component: () => import('@/pages/pages'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/page/new',
    name: 'page-page-new',
    component: () => import('@/pages/page'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/page/:id',
    name: 'page-page',
    component: () => import('@/pages/page'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
